import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";
import { Expo, TimelineLite, TimelineMax, TweenLite } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { AbstractStoryState } from "States/AbstractStoryState";
import { list } from "Utils/Reflection";

import {ch5_p14} from "../../../layouts/ch5_p14/ch5_p14";

export class Chapter5Page14 extends AbstractStoryState implements ReturnType<typeof ch5_p14> {

    readonly bg = this.addChild(new SceneSprite());
    readonly horse = this.addChild(new SceneSprite());
    readonly balloonLightBlue = this.addChild(new SceneSprite());
    readonly balloonYellow = this.addChild(new SceneSprite());
    readonly balloonBlue = this.addChild(new SceneSprite());
    readonly balloonRed = this.addChild(new SceneSprite());
    readonly balloonGreen = this.addChild(new SceneSprite());
    readonly balloons = this.addChild(new SceneSprite());
    readonly tyler = this.addChild(new SceneSprite());
    readonly tylerBack = this.addChild(new SceneSprite());
    readonly holly = [this.addChild(new SceneSprite()), this.addChild(new SceneSprite())];
    readonly tylerFront = this.addChild(new SceneSprite());
    readonly grass = this.addChild(new SceneSprite());
    readonly bush = this.addChild(new SceneSprite());

	readonly frameLeft = this.addChild(SceneSprite.withPrefix("ch5_p14/"));
	readonly frameRight = this.addChild(SceneSprite.withPrefix("ch5_p14/"));
	readonly linesLeft = this.addChild(SceneSprite.withPrefix("ch5_p14/"));
	readonly linesRight = this.addChild(SceneSprite.withPrefix("ch5_p14/"));

    dontScaleUp = true;

    public init(pSize: PIXI.Point, pData: any) {
		// exported layouts from Animate CC
        ch5_p14.call(this);

        this.grass.visible = false;

        this.balloons.visible = false;
        this.tylerBack.visible = false;
        this.tylerFront.visible = false;
        this.holly[1].visible = false;

		// super.init calls onResize
		super.init(pSize, pData);
	}

	public update(pDeltaTime: number) {
		super.update(pDeltaTime);
	}

	public animateIn(pOnComplete: ()=>void) {
        super.animateIn(pOnComplete);
    }

    public animateOut(pOnComplete: ()=>void) {
        super.animateOut(pOnComplete);
    }

    public onAnimateInComplete() {
        new TimelineLite()
        .call(()=>{
            this.grass.FadeIn();
        })
        .call(()=>{
            this.horse.FadeOut();
            this.balloonLightBlue.FadeOut();
            this.balloonYellow.FadeOut();
            this.balloonBlue.FadeOut();
            this.balloonRed.FadeOut();
            this.balloonGreen.FadeOut();
            this.holly[0].FadeOut();
            this.tyler.FadeOut();
            this.grass.FadeOut();

            this.balloons.FadeIn();
            this.tylerBack.FadeIn();
            this.holly[1].FadeIn();
            this.tylerFront.FadeIn();
            this.bush.FadeOut();
        }, undefined, undefined, "+=1.5")
        .call(()=>{
            super.onAnimateInComplete();
        }, undefined, undefined, "+=1.5")
        .call(()=>{
            this.gotoNextState({transition: "left"});
        }, undefined, undefined, "+=1.5")
    }
}